module.exports = __webpack_public_path__ + "static/media/facilities.7ac55961.png";